/**
 * Dashboard placeholder for the Meridian mobile app.
 *
 * This is the initial boilerplate view. It will be replaced with
 * real features like the contact graph, timeline, and network view
 * as the app takes shape. Mounted by App.tsx.
 */
import { usePlatform } from "../hooks/usePlatform";

export function Dashboard() {
  const { isNative } = usePlatform();

  return (
    <main
      className="flex flex-1 flex-col items-center justify-center px-8"
      style={{
        background: "radial-gradient(ellipse at 50% 40%, oklch(0.18 0.03 250), oklch(0.10 0.02 250) 70%)",
      }}
    >
      <div className="relative flex h-40 w-40 items-center justify-center">
        <div className="absolute inset-0 rounded-full border border-white/5" />
        <div className="absolute inset-5 rounded-full border border-white/8" />
        <div className="absolute inset-10 rounded-full border border-white/4" />
        <div
          className="absolute inset-0 rounded-full"
          style={{
            background:
              "radial-gradient(circle, oklch(0.55 0.12 45 / 0.10) 0%, transparent 65%)",
          }}
        />
        <span
          className="text-5xl font-thin"
          style={{ color: "oklch(0.72 0.12 45)" }}
        >
          M
        </span>
      </div>

      <h1
        className="mt-10 text-2xl font-medium tracking-wide"
        style={{ color: "oklch(0.88 0.01 250)" }}
      >
        Meridian
      </h1>

      <p
        className="mt-3 text-center text-sm leading-relaxed"
        style={{ color: "oklch(0.50 0.02 250)" }}
      >
        Every connection, one place.
      </p>

      <div
        className="mt-12 rounded-full px-5 py-2"
        style={{ border: "1px solid oklch(0.25 0.02 250)" }}
      >
        <p
          className="text-[11px] tracking-wider"
          style={{ color: "oklch(0.40 0.02 250)" }}
        >
          v0.1.0 · {isNative ? "native" : "web"}
        </p>
      </div>
    </main>
  );
}
